<div style="width: 200px;display: flex; flex-direction: column; justify-content: center; align-items: center;padding: 10px; font-size: 12px;">
    Test tooltip content ({{data.value}})
</div>